import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface AdditionalDocumentsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<AdditionalDocumentsServiceData>(db, 'additionalDocumentsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
